/* prettier-ignore */
export const content = {
  'designer.presence.multiplayer-presence.users.self': 'You',
  'designer.presence.multiplayer-presence.error.cannot-access-location':
    'Unable to access {{name}}\'s location.',
  'designer.presence.multiplayer-presence.error.cannot-access-variables-panel':
    'The variables panel is unavailable while you are localizing content.',
} as const;
